/**
 * @generated SignedSource<<4eed3f75d9fc37403b51a91c845bbcd5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentModuleUtils_useCurriculumModuleIdsRefetchQuery$variables = {
  id: string;
};
export type ContentModuleUtils_useCurriculumModuleIdsRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ContentModuleUtils_useCurriculumModuleIdsFragment">;
  } | null;
};
export type ContentModuleUtils_useCurriculumModuleIdsRefetchQuery = {
  response: ContentModuleUtils_useCurriculumModuleIdsRefetchQuery$data;
  variables: ContentModuleUtils_useCurriculumModuleIdsRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentModuleUtils_useCurriculumModuleIdsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContentModuleUtils_useCurriculumModuleIdsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentModuleUtils_useCurriculumModuleIdsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentUsageNodeConnection",
                "kind": "LinkedField",
                "name": "modules",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isReleased",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contentId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Curriculum",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bce03864f80222f0f5b3a61ff6714e0c",
    "id": null,
    "metadata": {},
    "name": "ContentModuleUtils_useCurriculumModuleIdsRefetchQuery",
    "operationKind": "query",
    "text": "query ContentModuleUtils_useCurriculumModuleIdsRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ContentModuleUtils_useCurriculumModuleIdsFragment\n    id\n  }\n}\n\nfragment ContentModuleUtils_useCurriculumModuleIdsFragment on Curriculum {\n  id\n  modules {\n    edges {\n      node {\n        id\n        isReleased\n        contentId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "754b85d98bbba26f4c3edb217a60ab2b";

export default node;
